import { Box, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { useDebtTrackingStore } from '../../hooks/useDebtTrackingStore';
import { formatMoney, formatWarehouseLabel } from '../../utils/debtTrackingUtils';

const useStyles = makeStyles((theme: Theme) => ({
  summary: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: theme.spacing(5),
    border: '1px solid #cdcdcd',
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(1.5, 2.5),
  },
  kicker: {
    flexBasis: '100%',
    fontWeight: 600,
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
  },
  value: {
    fontSize: '1.5rem',
    fontWeight: 700,
  },
}));

export const WarehouseSummary = observer(() => {
  const classes = useStyles();
  const { debtTrackingStore } = useDebtTrackingStore();
  const { selectedWarehouse, warehouseSummary } = debtTrackingStore;

  if (!selectedWarehouse) return null;

  return (
    <Box className={classes.summary}>
      <Typography className={classes.kicker}>{formatWarehouseLabel(selectedWarehouse)}</Typography>
      <Box>
        <Typography className={classes.label}>Total financing</Typography>
        <Typography className={classes.value}>{formatMoney(warehouseSummary?.totalFinancingAmount ?? 0)}</Typography>
      </Box>
      <Box>
        <Typography className={classes.label}>Loans</Typography>
        <Typography className={classes.value}>{warehouseSummary?.loanCount ?? 0}</Typography>
      </Box>
    </Box>
  );
});
